"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Checks if isDgSuperApp.
var useIsDgSuperApp = function () {
    var userAgent = window.navigator.userAgent;
    return userAgent.indexOf('DgSuperApp') !== -1;
};
exports.default = useIsDgSuperApp;
